module.exports = __webpack_public_path__ + "img/nazjzx-logo.f0362ba2.png";